import { useRef } from "react";
import { AllieLink } from "../../../components";
import { StyledAlliePopover, StyledLinkText } from "./ColumnLink.styles";
import { AllieDefaultColors } from "../../../common/color.types";

interface ColumnLinkProps {
  triggerId: string;
  href: string;
  value: string;
  maxLength?: number;
  width?: number;
  color?: AllieDefaultColors;
  className?: string;
}

interface LinkProps extends ColumnLinkProps {
  ellipsis?: boolean;
};

const Link: React.FC<LinkProps> = ({
  triggerId,
  href,
  value,
  ellipsis = false,
  width,
  ...props
}) => (
  <AllieLink
    className="allie-text-button-medium"
    size="default"
    style={{ padding: 0 }}
    href={href}
    id={triggerId}
    {...props}
  >
    <StyledLinkText ellipsis={ellipsis} width={width}>{value}</StyledLinkText>
  </AllieLink>
);

const MAX_TEXT_LENGTH = 29;
const DEFAULT_WIDTH = 250;

export const AllieColumnLink = ({
  triggerId,
  href,
  value,
  maxLength = MAX_TEXT_LENGTH,
  width = DEFAULT_WIDTH,
  color,
  className,
}: ColumnLinkProps) => {
  const tooltipRef = useRef<HTMLIonPopoverElement>(null);

  const popoverMouseEvents = {
    onmouseleave: () => {
      tooltipRef.current?.dismiss();
    },
  }

  return (
    <>
      <Link
        triggerId={triggerId}
        href={href}
        value={value}
        ellipsis={true}
        width={width}
        color={color}
        className={className}
      />
      {
        value.length > maxLength && (
          <StyledAlliePopover
            ref={tooltipRef}
            trigger={triggerId}
            triggerAction="hover"
            alignment="center"
            side="top"
            showBackdrop={false}
            content={{
              className: "ion-padding",
              children: (
                <Link
                  triggerId={triggerId}
                  href={href}
                  value={value}
                />
              ),
              ...popoverMouseEvents
            }}
          />
        )
      }
    </>
  );
};
